export default __webpack_public_path__ + "static/media/img--interiors-1.44dddde7.jpg";